// Convierte cualquier URL de YouTube en URL de embebido responsive.
export function toYoutubeEmbed(url) {
  if (!url) return "";
  const u = url.trim();
  if (u.includes("/embed/")) return u;
  let id = "";
  const patterns = [
    /(?:youtube\.com\/watch\?v=)([\w-]{11})/,
    /(?:youtu\.be\/)([\w-]{11})/,
    /(?:youtube\.com\/shorts\/)([\w-]{11})/,
    /(?:youtube\.com\/live\/)([\w-]{11})/,
    /(?:youtube\.com\/v\/)([\w-]{11})/,
  ];
  for (const p of patterns) {
    const m = u.match(p);
    if (m) { id = m[1]; break; }
  }
  if (!id && /^[\w-]{11}$/.test(u)) id = u;
  return id ? `https://www.youtube.com/embed/${id}` : "";
}

export const ARTICLE_STATES = {
  draft: { label: "Borrador", color: "#FF6B35", bg: "bg-orange-100 text-orange-700" },
  in_review: { label: "En revisión", color: "#8A2BE2", bg: "bg-violet-100 text-violet-700" },
  approved: { label: "Aprobado", color: "#0055FF", bg: "bg-blue-100 text-blue-700" },
  published: { label: "Publicado", color: "#16a34a", bg: "bg-green-100 text-green-700" },
  rejected: { label: "Rechazado", color: "#dc2626", bg: "bg-red-100 text-red-700" },
  archived: { label: "Archivado", color: "#6b7280", bg: "bg-gray-200 text-gray-600" },
};
